import { userManager } from "@core/service-container";
import { User } from "@domain/user/user";
import { useObservable } from "micro-observables";

export const useUser = (): User | null => useObservable(userManager.user);
